import { installChannel, isTelegramEnv } from './capabilities.js';
import { createPwaAdapter } from './pwa/PwaAdapter.js';
import { createTmaAdapter } from './tma/TmaAdapter.js';

// Telegram detection lives in the pure lowest layer (capabilities.js) so main.js
// and every device check share one reading; re-exported here unchanged.
export { isTelegramEnv } from './capabilities.js';

/**
 * Where the app is running, sent to the API on every call as `X-Poolit-Surface`
 * (src/httpConfig/config/axios.js) so the admin "Supplier activity" window can
 * tell a Telegram Mini App open from an installed PWA or a plain browser tab.
 */
export function appSurface() {
  const channel = installChannel();
  if (channel === 'tma') return 'tg_mini_app';
  return channel === 'installed' ? 'pwa_installed' : 'browser';
}

function detectPlatform() {
  return isTelegramEnv() ? 'tma' : 'pwa';
}

export const platformType = detectPlatform();

export const adapter = platformType === 'tma'
  ? createTmaAdapter()
  : createPwaAdapter();

// Live alias — re-evaluates all seven Telegram-detection signals on every call.
// Replaces the frozen `() => platformType === 'tma'` snapshot to fix the boot-
// race where Telegram globals load after module init (PWA audit MEDIUM-2;
// playbook Section 1 invariant "TMA must NOT register a SW"; Section 5 row 9).
export const isTma = isTelegramEnv;
export const isPwa = () => platformType === 'pwa';
